import React from 'react';
import {Button, Modal} from "react-bootstrap";

interface IModifyCustomerCardConfirmModalProps {
    handleConfirmSubmit: () => void;
    handleConfirmReject: () => void;
    isUpdate?: boolean;
}

export function ModifyCustomerCardConfirmModal(props: IModifyCustomerCardConfirmModalProps) {

    const confirmSubmit = () => {
        props.handleConfirmSubmit();
    };
    const rejectSubmit = () => {
        props.handleConfirmReject();
    };

    return (
        <>
            <Modal
                show={true}
                size={"lg"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={rejectSubmit}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {
                            props.isUpdate ? "Taotluse uuendamine" : "Taotluse kinnitamine"
                        }
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="">
                        {
                            props.isUpdate ? "Kas oled kindel, et soovid taotlust uuendada?" : "Kas oled kindel, et soovid taotlust esitada?"
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="outline-dark"
                            onClick={() => rejectSubmit()}
                            type="button"
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>
                            {
                                props.isUpdate ? 'Tühista' : 'Loobu'
                            }
                        </span>
                    </Button>
                    <Button variant="primary" onClick={confirmSubmit} type="button"
                            className="d-flex align-items-center">
                            <span className='px-2'>
                                {
                                    props.isUpdate ? 'Salvesta' : 'Saada taotlus'
                                }
                            </span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
